import appConfig from '../../config/appConfig';
import Profile from '../../api/Profile';

const profileConfig = {
  namespaced: true,
  state: {
    profile: {},
    profileLoaded: false,
    templates: undefined,
    mapTemplate: undefined,
    mapProfileLoaded: false,
    profileDataLoaded: false,
    stateDefaultProfile: {},
    facilityDefaultProfile: {}
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
      setDerivativeProfileProps(state);
    },
    setProfileLoaded(state, loaded) {
      state.profileLoaded = loaded;
    },
    setMapProfileLoaded(state, loaded) {
      state.mapProfileLoaded = loaded;
    },
    setStateDefaultProfile(state, profile) {
      state.stateDefaultProfile = profile;
      // TODO: setDerivativeStateDefaultProfileProps(state);
    },
    setFacilityDefaultProfile(state, profile) {
      state.facilityDefaultProfile = profile;
      // TODO: setDerivativeFacilityDefaultProfileProps(state);
    },
    setProfileDataLoaded(state, value) {
      state.profileDataLoaded = true;
    }
  },
  getters: {
    profile: (state) => {
      return state.profile;
    },
    profileLoaded: (state) => {
      return state.profileLoaded;
    },
    templates: (state) => {
      return state.templates;
    },
    mapTemplate: (state) => {
      return state.mapTemplate;
    },
    profileHasMap: (state) => {
      return state.mapTemplate != undefined;
    },
    mapProfileLoaded: (state) => {
      return state.mapProfileLoaded;
    },
    profileDataLoaded: (state) => {
      return state.profileDataLoaded;
    },
    stateDefaultProfile: (state) => {
      return state.stateDefaultProfile;
    },
    facilityDefaultProfile: (state) => {
      return state.facilityDefaultProfile;
    }
  }
};

const appendJsonExtension = (filename) => {
  return filename.endsWith('.json') ? filename : `${filename}.json`;
};

const setDerivativeProfileProps = (state) => {
  if (!state.profile || !state.profile.templates) {
    return;
  }

  // Templates
  state.templates = state.profile.templates.filter((t) => t.type != 'map');

  // Map Template
  const mapTemplates = state.profile.templates.filter((t) => t.type == 'map');
  state.mapTemplate =
    mapTemplates && mapTemplates.length > 0 ? mapTemplates[0] : undefined;
};

export default profileConfig;
